import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DayStatus } from '../helpers';
import moment from 'moment';
import { DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import humanizeDuration from 'humanize-duration';
import _ from 'lodash';

@Component({
  selector: 'app-manage-day-modal',
  templateUrl: './manage-day-modal.component.html',
  styleUrls: ['./manage-day-modal.component.css']
})
export class ManageDayModalComponent implements OnInit {

  @Input() selectedDay: Date;
  @Input() dayEvents: Array<any>;
  @Input() modalRef: NgbModalRef;
  @Input() dayStatus: DayStatus;

  @Output() action = new EventEmitter();

  hasOnlineExperiences = false;

  timeForm = new DVFormGroup({
    time: new DVFormControl(null, {
      'time is required': Validators.required
    }),
    durationInMinutes: new DVFormControl(null, {
      'duration is required': Validators.required
    })
  });

  durations = _.range(1, 11).map(v => ({
    display: humanizeDuration(v * 30 * 60 * 1000, {
      units: ['h', 'm']
    }),
    value: v * 30
  }));


  get noEventsText() {
    if (this.dayStatus === 'BLOCKED') {
      return 'This day has no Experiences, would you like to unblock it?';
    } else if (this.dayStatus === 'PARTIALLY_BLOCKED') {
      return 'This day has no Experiences, but it is blocked in some experience. What would you like to do?';
    } else {
      return 'This day has no Experiences, would you like to block it?';
    }
  }

  get note() {
    if (this.dayStatus === 'BLOCKED') {
      return 'By unblocking this day all the above experiences will be available to book';
    } else if (this.dayStatus === 'PARTIALLY_BLOCKED') {
      return 'This day has a mix of Blocked and Available Experience as mentioned above.';
    } else {
      return 'By blocking this day all the above experiences will be unavailable. you can undo this change later';
    }
  }

  constructor() { }

  ngOnInit() {
    for (const e of this.dayEvents) {
      if (!e.allDay) {
        this.hasOnlineExperiences = true;
        break;
      }
    }
  }


  getEventDateString(event) {
    if (event.allDay) {
      return moment(event.start).format('LL');
    } else {
      return moment(event.start).format('LLLL');
    }
  }

  cancel() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
    this.action.emit({
      action: 'hide'
    });
  }

  block() {
    this.action.emit({
      action: 'block',
    });
  }

  blockDurationSubmit() {
    if (!this.timeForm.valid) {
      this.timeForm.forceShowErrors();
    } else {
      const value = this.timeForm.value;
      this.action.emit({
        action: 'blockTime',
        value
      });
    }
  }

  unblock() {
    this.action.emit({
      action: 'unblock',
    });
  }

}
